'use client';

import { Modal } from './Modal';
import { Button } from './Button';
import { AlertCircle, Calendar } from 'lucide-react';

interface ResearchLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  used: number;
  limit: number;
}

export function ResearchLimitModal({ isOpen, onClose, used, limit }: ResearchLimitModalProps) {
  const percentage = Math.min(100, Math.round((used / limit) * 100));

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Monthly Limit Reached">
      <div className="text-center">
        <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-amber-900/50 flex items-center justify-center">
          <AlertCircle className="w-8 h-8 text-amber-500" />
        </div>

        <h3 className="text-lg font-semibold text-[var(--color-text)] mb-2">
          Research report limit reached
        </h3>
        <p className="text-[var(--color-text-secondary)] mb-6">
          You&apos;ve used all {limit} research reports for this month.
        </p>

        <div className="bg-[var(--color-bg)] rounded-lg p-4 mb-6">
          <div className="flex justify-between text-sm mb-2">
            <span className="text-[var(--color-text-secondary)]">This month&apos;s usage</span>
            <span className="text-[var(--color-text)] font-medium">{percentage}%</span>
          </div>
          <div className="w-full bg-[var(--color-surface-hover)] rounded-full h-2 mb-3">
            <div
              className="bg-amber-500 h-2 rounded-full transition-all"
              style={{ width: `${percentage}%` }}
            />
          </div>
          <div className="flex justify-between text-xs text-[var(--color-text-muted)]">
            <span>{used} of {limit} reports used</span>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm text-[var(--color-text-secondary)] mb-6">
          <Calendar size={16} />
          <span>Reports reset on the 1st of each month</span>
        </div>

        <Button onClick={onClose} className="w-full">
          Got it
        </Button>
      </div>
    </Modal>
  );
}
